import GalleryFeaturesCentered from './features-centered/script';
import GalleryImages from './images/script';
import GalleryParts from './parts/script';
import GalleryTeam from './team/script';
import GalleryVideoPlaylist from './video-playlist/script';
import GalleryVideos from './videos/script';

export default {
	[GalleryFeaturesCentered.selector]: GalleryFeaturesCentered,
	[GalleryImages.selector]: GalleryImages,
	[GalleryParts.selector]: GalleryParts,
	[GalleryTeam.selector]: GalleryTeam,
	[GalleryVideoPlaylist.selector]: GalleryVideoPlaylist,
	[GalleryVideos.selector]: GalleryVideos
};
